<template>
  <div class="left">
    <div class="leftBox">
      <el-tree
        :data="navData"
        node-key="id"
        :default-expanded-keys="default_expanded"
        :current-node-key="leftCurrentNode"
        :props="defaultProps"
        check-strictly
        highlight-current
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
  </div>
</template>
<script>
import magic from "@/../static/common/magic.js";
export default {
  props: {
    leftCurrentNode: {
      type: Number
    },
    default_expanded: {
      type: Array
    },
    navData: {
      type: Array,
      default: function() {
        return [
          {
            id: 0,
            label: "医药行业",
            children: [
              {
                id: 1,
                label: "化学制剂",
                children: [
                  {
                    id: 10,
                    path: "/pharma/chemicalMajor",
                    label: "化学药品制剂主要品种产量"
                  },
                  {
                    id: 11,
                    path: "/pharma/midbody",
                    label: "化学制药中间体品种产量、出口量"
                  },
                  {
                    id: 12,
                    path: "/pharma/twentyFour",
                    label: "化学原料药二十四大类品种产量、出口量"
                  }
                ]
              },
              {
                id: 4,
                label: "中药生物制剂",
                children: [
                  {
                    id: 13,
                    path: "ChineseMedicine",
                    label: "中药生物制药主要品种产量"
                  }
                ]
              },
              {
                id: 5,
                label: "医疗器械",
                children: [
                  {
                    id: 14,
                    path: "/pharma/instrument",
                    label: "医药器械主要品种产量"
                  },
                  {
                    id: 15,
                    path: "/pharma/thirdly",
                    label: "NMPA批准的境内第三类医疗器械"
                  }
                ]
              },
              {
                id: 6,
                label: "批准新药情况",
                children: [
                  {
                    id: 16,
                    path: "/pharma/newDrugs",
                    label: "批准新药"
                  }
                ]
              },
              {
                id: 7,
                label: "医药企业情况",
                children: [
                  {
                    id: 17,
                    path: "/pharma/DrugForm",
                    label: "医药企业名录"
                  },
                  {
                    id: 18,
                    path: "/pharma/standard",
                    label: "通过《药品生产质量管理规范》认证的企业"
                  },
                  {
                    id: 19,
                    path: "/pharma/international",
                    label: "通过制剂国际认证的企业"
                  }
                ]
              },
              {
                id: 8,
                label: "医院用药情况",
                children: [
                  {
                    id: 20,
                    path: "/pharma/emphasis",
                    label: "主要城市重点医院用药品种金额排序"
                  }
                ]
              },
              {
                id: 9,
                label: "医药进出口",
                children: [
                  {
                    id: 21,
                    path: "/pharma/tradingSum",
                    label: "进出口金额"
                  },
                  {
                    id: 22,
                    path: "/pharma/tradingAmount",
                    label: "进出口数量"
                  }
                ]
              }
            ]
          },
          {
            id: 1,
            path: "/customs",
            label: "海关企业(停)"
          },
          {
            id: 2,
            path: "/industrial",
            label: "规上工业企业(停)"
          }
        ];
      }
    },
   
    defaultProps: {
      type: Object,
      default: function() {
        return {
          children: "children",
          label: "label"
        };
      }
    }
  },
  components: {},
  data() {
    return {
      params: {
        dbcode: 1 //这里需要加上这个参数来判断登录
      },

      openeds: ["1"] //导航栏展开
    };
  },
  // watch: {
  //   "$route.query.id": function(n, o) {
  //     this.currentNode = n;
  //   },

  // },
  computed: {},
  methods: {
    getParams() {
      let creditCode = magic.getUrlKey("creditCode"); //假数据
      this.params["creditCode"] = creditCode;
    },
    handleNodeClick(data) {
      // console.log(data);
      this.$router.push({
        path: data.path,
        query: this.params
      });
    }
  },
  created() {},
  mounted() {
    this.getParams();
  }
};
</script>
<style scoped lang="less">
// 左侧菜单栏
.left {
  width: 240px;
  height: 100%;
  min-height: 80vh;
  // margin-right: 23px;

  .leftBox {
    width: auto;
    height: 100%;
    // padding: 3px 14px 26px 14px;

    .headline {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .el-menu {
      border-right: none;
    }
    /deep/ .el-submenu__icon-arrow {
      right: 2px;
    }
    /deep/ .el-submenu__title {
      padding: 0;
      padding-left: 5px !important;
      border-bottom: 1px dashed #dfdfdf;
    }
    .el-submenu .el-menu-item {
      padding-left: 25px !important;
      padding: 0px;
      display: inline-block;
      width: 200px;
    }
    /deep/ .el-submenu__title:hover {
      background-color: #f2f4f7 !important;
    }
    .el-menu-item:hover {
      background-color: #f2f4f7 !important;
    }
    #moreText {
      padding-top: 6px;
      line-height: 20px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
    }
  }
}
/deep/ .el-tree {
  background: rgba(5, 43, 79, 0.3);
  border: 1px solid #08396a;
  height: 100%;
  // height: 809px;
}
/deep/ .el-tree-node__content {
  height: 50px;
  // background: none !important;
  color: #fff;
}

/deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #376CA5 !important;
}
/deep/ .el-tree-node__content:hover {
  background: transparent !important;
}
/deep/.el-tree-node__label {
  word-break: break-all;
  white-space: normal;
}
// /deep/ .is-current .el-tree-node__label{
//   color:rgb(53, 131, 237) !important;
// }
// /deep/ .is-current /deep/.el-tree-node__label {
//   color: #177fe8 !important;
// }
</style>


// WEBPACK FOOTER //
// src/components/leftNav.vue